import React, { memo, useState } from 'react';
import { Pie, measureTextWidth } from '@ant-design/plots';

import {useTranslation} from "react-i18next";

import { Typography, Radio } from 'antd';
// styles
import './style.scss';

function HomeDonatChart() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('week');

  function renderStatistic(containerWidth, text, style) {
    const { width: textWidth, height: textHeight } = measureTextWidth(
      text,
      style,
    );
    const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

    let scale = 1;

    if (containerWidth < textWidth) {
      scale = Math.min(
        Math.sqrt(
          Math.abs(
            Math.pow(R, 2) /
              (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)),
          ),
        ),
        1,
      );
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${scale}em;line-height:${
      scale < 1 ? 1 : 'inherit'
    };color:white">${text}</div>`;
  }

  const data = {
    week: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 15,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 4,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 31,
      },
    ],
    month: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 20,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 30,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 44,
      },
    ],
    semester: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 64,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 40,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 80,
      },
    ],
  };

  const config = {
    appendPadding: 10,
    data: data[tab],
    color: ['#568DF6', '#60779D', '#EBB917'],
    angleField: 'value',
    colorField: 'type',
    radius: 1,
    innerRadius: 0.64,
    label: {
      type: 'inner',
      offset: '-50%',
      style: {
        textAlign: 'center',
      },
      autoRotate: false,
      content: '{value}',
    },
    statistic: {
      title: {
        offsetY: -4,
        customHtml: (container, view, datum) => {
          const { width, height } = container.getBoundingClientRect();
          const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
          const text = datum ? datum.type : 'Absences';
          return renderStatistic(d, text, {
            fontSize: 10,
          });
        },
      },
      content: {
        offsetY: 4,
        style: {
          fontSize: '32px',
        },
        customHtml: (container, view, datum, data) => {
          const { width } = container.getBoundingClientRect();
          const text = datum
            ? datum.value
            : data.reduce((r, d) => r + d.value, 0);
          return renderStatistic(width, text, {
            fontSize: 10,
          });
        },
      },
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
      {
        type: 'pie-statistic-active',
      },
    ],
    legend: {
      itemName: {
        style: {
          fill: '#ffffff',
        },
      },
    },
  };

  return (
    <div className="absence-statistics">
      <Typography.Title level={3} className="heading-title">
        {t("absences.absencesStatistics")}
      </Typography.Title>
      <div className="tab-container">
        <Radio.Group
          options={[
            { label: t("absences.week") , value: 'week' },
            { label: t("absences.month") , value: 'month' },
            { label: t("absences.semester") , value: 'semester' },
          ]}
          buttonStyle="solid"
          optionType="button"
          value={tab}
          onChange={e => setTab(e.target.value)}
          className="tab-container--tab"
        />
      </div>
      <div className="bar-chart">
        <Pie {...config} height={260} />
      </div>
    </div>
  );
}

HomeDonatChart.defaultProps = {};
HomeDonatChart.propTypes = {};

export default memo(HomeDonatChart);
